import React, { useState, useEffect } from 'react'
import { Button, Flex, Select, Spin, Input, notification, Row, Col, Drawer, Tag, Checkbox } from 'antd';
import CustomerObject, { CUSTOMER_SOURCE, CUSTOMER_STATUS, statusColor } from '../../objects/CustomerObject';
import { isMobile } from 'react-device-detect';
import { getDate } from '../../common/Converter';


export default function CustomerRowComponent(props) {
    const { customer, openDetail, onChangeCheck, keyOfRow, isCheckAll, index } = props
    const source = Object.values(CUSTOMER_SOURCE).find(t => t.key === customer.source);
    const status = Object.values(CUSTOMER_STATUS).find(t => t.key === customer.status)
    const [isChecked, setIsChecked] = useState(false)
    useEffect(() => {
        setIsChecked(isCheckAll)
    }, [isCheckAll])

    return (
        <Row
            className='customer-info'
            key={keyOfRow}
            style={{ backgroundColor: index % 2 == 0 ? "#f0f5ff" : "white", margin: 0, paddingTop: isMobile?"5px":0, paddingBottom: isMobile?'5px':0, cursor: 'pointer', height:'min-content', alignItems: 'center' }}
        >
            {/* <Col flex="30px"> </Col> */}
            <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '20%' }} xl={{ flex: '20%' }} style={{ alignItems: 'center', display: "flex", maxHeight: '20px' }} >
                <Checkbox checked={isChecked} onChange={(e) => {
                    setIsChecked(e.target.checked);
                    onChangeCheck(e.target.checked);
                    console.log("Clicked checkbox", e.target.checked)
                }}></Checkbox> &nbsp;&nbsp;&nbsp;
                <div onClick={openDetail} style={{overflow:"hidden", textOverflow:"ellipsis", display:"-webkit-box", WebkitLineClamp:1, lineClamp:1, whiteSpace:'nowrap'}}><span style={{ fontWeight: "bold" }}>{customer.name}</span> <span style={{ fontStyle: 'italic' }}>{isMobile ? `(UserId: ` : null}{isMobile ? <span style={{ fontWeight: "bold" }}>{customer.userId}</span> : null}{isMobile ? ")" : null}</span></div>
            </Col>
            <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }} style={{ alignItems: 'center', display: "flex" }}
                onClick={openDetail}>{isMobile ? "" : customer.userId}</Col>
            {
                isMobile ?
                    null :
                    <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }} style={{ alignItems: 'center', display: "flex" }}
                        onClick={openDetail}>{source ? source.label : "Không rõ nguồn gốc"}</Col>
            }
            <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }} style={{ alignItems: 'center', display: "flex" }}
                onClick={openDetail}>
                <i>{isMobile ? `Hạn sử dụng: ` : ""}</i>&nbsp;{getDate(customer.expired / 1000)}
            </Col>
            <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '20%' }} lg={{ flex: '20%' }} xl={{ flex: '20%' }} style={{ alignItems: 'center', display: "flex", height: 'auto' }}
                onClick={openDetail}>{isMobile ? <i>Mã trường: </i> : null}&nbsp;{customer.schoolData ? customer.schoolData.name : customer.school}</Col>
            <Col xs={{ flex: '99%' }} sm={{ flex: '99%' }} md={{ flex: '39%' }} lg={{ flex: '14%' }} xl={{ flex: '14%' }} style={{ alignItems: 'center', maxHeight: '20px' }}
                onClick={openDetail}><Tag color={statusColor(status?.key)}>{status ? status.label : "Không rõ trạng thái"}</Tag></Col>
        </Row>
    );
}